import Image, { StaticImageData } from 'next/image';
import { CSSProperties, ReactEventHandler } from 'react';

export type BannerProps = {
  imagemUrl: string | StaticImageData;
  style?: CSSProperties;
  descricaoImagem: string;
  priority: boolean;
  onLoad?: ReactEventHandler<HTMLImageElement>;
  propsNextImage?: object;
};

export default function Banner(props: BannerProps) {
  const {
    imagemUrl,
    descricaoImagem,
    priority = true,
    style,
    onLoad = () => {},
    propsNextImage = undefined,
  } = props;

  return (
    <Image
      src={imagemUrl}
      alt={descricaoImagem}
      priority={priority}
      fill
      sizes="100vw"
      style={{
        objectFit: 'cover',
        ...style,
      }}
      onLoad={onLoad}
      {...propsNextImage}
    />
  );
}
